
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ApplicationsPage from '../pages/applications/page';
import ProductCharacteristicsPage from '../pages/product-characteristics/page';
import ContactPage from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/applications',
    element: <ApplicationsPage />,
  },
  {
    path: '/product-characteristics',
    element: <ProductCharacteristicsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
